import React from 'react';
import '../../assets/css/spinner.css';

const Spinner = () => {
  return (
    <div className="custom-spinner-wrapper">
      <div className="custom-spinner"></div>
    </div>
  );
};

export default Spinner;
